import { DelegatedTaskStatusFilter } from '@/pages/delegations/delegated-task/utils/constant';

export default {
  type: 'select',
  name: 'status',
  label: 'global.text.status',
  locale: true,
  options: DelegatedTaskStatusFilter(),
  showSearch: true,
  allowClear: true,
  labelInValue: false,
};
